import { Component } from '@angular/core';
import { ScreenLegendComponent } from 'libs/shared/src/lib/component/screen/legend/legend.component';

@Component({ standalone: false, selector: 'app-screen-legend', templateUrl: './legend.component.html' })
export class CustomScreenLegendComponent extends ScreenLegendComponent {}
